Vue.component('panel-calendar', {
	props: ["options", "labellang", "lang"],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="panel-calendar" class="panel-widget">' +
		'<div class="overlay-content text-center">' +
		'<h3>{{ title }}</h3>' +
		'<div class="input-group date" id="datetimepicker1">' +
		'<input id="calendarField" name="txt" type="text" @keyup.enter="sendWidget" class="form-control" readonly />' +
		'<span class="input-group-addon">' +
		'<span class="glyphicon" :class="typeIcon"></span>' +
		'</span>' +
		'</div>' +
		'</div>' +
		'<div class="overlay-footer">' +
		'<button v-if="btCancelVisible" @click="closeView" class="btn pull-left" > {{ cancel }} </button>' +
		'<button  @click="sendWidget"  class="btn btn-info pull-right"  data-language="send" >{{ send }}</button>' +
		'</div>' +
		'</div>' +
		'</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			defaultDate: new Date(),
			title: null,
			send: this.labellang.webcb_send_button,
			cancel: this.labellang.cancel,
			currentDateSelect: null,
			btCancelVisible: false,
			currentLocale: moment.locale(this.lang),
			typeIcon: null,
			typeFormat: null,
			eventFromForm: false
		}
	},
	mounted: function () {
		var that = this;
		bus.$on('onShowPanelCalendar', function (val) {
			that.contentShow(val);
		})

		bus.$on('onCallTypeCalendar', function (optionCalendar) {
			that.callTypeCalendar(optionCalendar);
		})
	},
	methods: {
		contentShow: function (val) {
			this.isActive = val?true:false;
			this.defaultDate = new Date();//Se viene passato true metto la data di oggi. se invece è un valore data lo uso
			if (val!==true && val.length>0) {
				this.defaultDate = val;
			}
			if (this.isActive) {
				setTimeout(function () {
					document.getElementById("calendarField").focus();
				}, 1100);
			}
		},
		callTypeCalendar: function (optionCalendar) {
			var formatDate = "L";
			if (optionCalendar.fromForm) {
				this.eventFromForm = true;
			}
			if (optionCalendar.attributes && optionCalendar.attributes.format) {
				formatDate = optionCalendar.attributes.format;
			}
			switch (optionCalendar.type) {
				case "date":
					this.typeIcon = "glyphicon-calendar";
					this.title = this.labellang.title_calendar_date || "Enter a date:"
					this.typeFormat = formatDate // custom date format
					break;
				case "time":
					this.typeIcon = "glyphicon-time";
					this.typeFormat = "LT" // only time
					this.title = this.labellang.title_calendar_hours || "Enter a time:"
					break;
				case "datetime":
					this.typeIcon = "glyphicon-calendar";
					this.typeFormat = "LLL" // only time
					this.title = this.labellang.title_calendar_date_time || "Enter a date and time:"
					break;
				default:
					this.typeIcon = "glyphicon-calendar";
					this.title = this.labellang.title_calendar_date || "Enter a date:"
					this.typeFormat = "LLL" // only 
			}

			this.callCalendar();
		},
		callCalendar: function () {
			//Se la data è una stringa, la trasformo in oggetto data prima di darla al plugin
			if (typeof this.defaultDate !== "object") {
				this.defaultDate = moment(this.defaultDate, this.typeFormat).toDate();
				if (this.defaultDate == "Invalid Date") {
					this.defaultDate = new Date();
				}
			}
			var optionsPicker = {
				locale: this.currentLocale,
				format: this.typeFormat,
				defaultDate: this.defaultDate,
				ignoreReadonly: true
			};
			Vue.nextTick(function () {
				$('#datetimepicker1').datetimepicker(optionsPicker);
			})
		},
		closeView: function () {
			this.isActive = false;
		},
		sendWidget: function () {
			var inputTxt = $('#datetimepicker1').find("input[name=txt]").val();

			if (inputTxt.length && this.isActive) {
				this.currentDateSelect = $('#datetimepicker1').data("DateTimePicker").viewDate()
				this.currentDateSelect = moment(this.currentDateSelect).format(this.typeFormat);
				this.defaultDate = new Date();
				if (this.eventFromForm) {
					bus.$emit("onCloseDateWidgetInForm", this.currentDateSelect);
					this.isActive = false;
					this.eventFromForm = false;
				}
				else {
					bus.$emit("onCloseWidget", this.currentDateSelect);
					this.isActive = false;
				}
			}

		}
	}
})
